import { useState, useEffect } from 'react';

/**
 * Hook to detect if the current viewport is mobile based on a breakpoint
 * @param {number} breakpoint - The breakpoint in pixels (default: 992)
 * @returns {boolean} - True if the viewport width is below the breakpoint
 */
export const useMobile = (breakpoint = 992) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

